import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=d25ae162&scoped=true&"
import script from "./PriceFilter.vue?vue&type=script&lang=js&"
export * from "./PriceFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=d25ae162&lang=scss&scoped=true&"
import style1 from "./PriceFilter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25ae162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d25ae162')) {
      api.createRecord('d25ae162', component.options)
    } else {
      api.reload('d25ae162', component.options)
    }
    module.hot.accept("./PriceFilter.vue?vue&type=template&id=d25ae162&scoped=true&", function () {
      api.rerender('d25ae162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Filters/PriceFilter.vue"
export default component.exports